import React from "react";
import { Card, Headline, Paragraph } from "_styleguide";

function NotFound(props) {
  return (
    <Card id="not-found">
      <Headline>This page is not currently enabled</Headline>
      <Paragraph>
        Please contact your administrator if you believe this is an error.
      </Paragraph>
    </Card>
  );
}

export default NotFound;
